export default __webpack_public_path__ + "static/media/send-grey.8c9a92b7.svg";